const firebaseConfig = {
  apiKey: "AIzaSyCTWjvWKteoPGFufILi-dZq-GNTcQnsd_Q",
  authDomain: "md-bappy-mia.firebaseapp.com",
  projectId: "md-bappy-mia",
  storageBucket: "md-bappy-mia.appspot.com",
  messagingSenderId: "743973324874",
  appId: "1:743973324874:web:97e260dcac17a716d07eb3",
};
export default firebaseConfig;
